import { Controller } from '@hotwired/stimulus'
// #AI: jQuery is loaded via Sprockets as a global variable
const $ = window.jQuery || window.$;

export default class extends Controller {
  static targets = ['form']

  initialize() {
    $(this.formTarget).on('change', this.postFormToSaveChanges().bind(this))
  }

  postFormToSaveChanges() {
    return () => {
      Rails.fire(this.formTarget, 'submit')
    }
  }
}
